namespace Gordic.Adm.WebControls.GAdmUtils {
    /**
     * Návratový objekt z createGridFromResponseWithMeta()
     * */
    export class CreateGridFromResponse<TRow = any> {
        public view: Gordic.Data.View<TRow>;
        public format: Gordic.Data.GridFormat<any>;
        public search: any[];
    }

    /**
     * Funkce vytvoří z response objektu od serverové ISL funkce Isl.ListWithMeta() objekty potřebné pro posatavení GridView na formuláři. Vrací objekt response, který 
     * obsahuje odpovídající objekty:
     *  view
     *  format
     *  search
     * @param a_response
     */
    export function createGridFromResponseWithMeta<TRow = any, TMeta extends Gordic.General.ApplicationInterface.GDataListDescription = Gordic.General.ApplicationInterface.GDataListDescription>(
        a_response: Gordic.Isl.GServiceListResponseWithMeta<TRow, TMeta>
    ): CreateGridFromResponse {

        var maxCollChars = 50;
        var lSearch: any[] = [];
        var lIndex = 0;
        var lView = new Gordic.Data.View(a_response.data);
        var lFormat = new Gordic.Data.GridFormat();


        (a_response?.meta?.list_fields)?.forEach(function (list_field: any) {

            //var lObjFormat = { name: rElement.field_name, caption: rElement.field_caption, width: 500, fixedWidth: false, visible: rElement.field_visible, description: "" };
            var v_caption = new String(list_field.field_caption);
            var v_char_width = 8;
            var v_char_caption_width = 9.3;
            var v_caption_add = 2;
            var v_coll_add = 2;
            var v_sirka = 0;
            var v_sirka_nadpisu = 0;

            if (list_field.field_visible) {
                if (list_field.field_base_type === "TEXT") {
                    v_sirka = list_field.field_max_data_size;
                    if (v_sirka > maxCollChars)
                        v_sirka = maxCollChars;
                    if (v_sirka < 10)
                        v_sirka = 10;

                    v_sirka = (v_sirka + v_coll_add) * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addTextColumn(
                        {
                            name: list_field.field_name,
                            caption: list_field.field_caption,
                            width: v_sirka,
                            fixedWidth: false,
                            visible: list_field.field_visible,
                            description: ""
                        }
                    );
                }
                if (list_field.field_base_type === "NUMBER") {
                    v_sirka = 7;

                    v_sirka = v_sirka * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addNumberColumn(
                        {
                            name: list_field.field_name,
                            caption: list_field.field_caption,
                            width: v_sirka,
                            fixedWidth: true,
                            visible: list_field.field_visible,
                            description: ""
                        }
                    );
                }
                if (list_field.field_base_type === "DATE") {
                    v_sirka = 6;

                    v_sirka = v_sirka * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addDateColumn(
                        {
                            name: list_field.field_name,
                            caption: list_field.field_caption,
                            width: v_sirka,
                            fixedWidth: true,
                            visible: list_field.field_visible,
                            description: ""
                        }
                    );
                }
                if (list_field.field_base_type === "DATETIME") {

                    v_sirka = 16;

                    v_sirka = v_sirka * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addDateTimeColumn(
                        {
                            name: list_field.field_name,
                            caption: list_field.field_caption,
                            width: v_sirka,
                            fixedWidth: true,
                            visible: list_field.field_visible,
                            description: ""
                        }
                    );
                }
                // jmena vsech sloupcu pro search
                if (list_field.field_visible) {
                    lSearch[lIndex++] = list_field.field_name;
                }
            }
        });
        
        var lObj: CreateGridFromResponse = { view: lView, format: lFormat, search: lSearch };

        return lObj;
    }

    /**
     * pomocná funkce pro vytvoření tabulky podle definice metadat získaných ze serveru společně s daty gridu
     * - přepsána z JS, poté co zahodíme tu v javascriptu, můžeme použít pouze tuto (a tuto taky můžeme zoptimalizovat)
     * 
     * @param {any} aData
     * @param {any} maxCollChars
     */
    export function createGrid(aData: any, maxCollChars?: any) {

        /// <summary>
        /// Funkce pro vytvoření definice gridu podle zadané definice
        /// </summary>
        /// <param name="aData" type="GDataListResponse">Kompletní popisná data seznamu vrácená ze serveru</param>
        if (maxCollChars === undefined)
            maxCollChars = 50;

        var lSearch: any[] = [];
        var lIndex = 0;
        var lView = new Gordic.Data.View(aData.data_list.list_data);
        var lFormat = new Gordic.Data.GridFormat();


        $(aData.data_list.list_description.list_fields).each(function (rIndex, rElement: any) {

            //var lObjFormat = { name: rElement.field_name, caption: rElement.field_caption, width: 500, fixedWidth: false, visible: rElement.field_visible, description: "" };
            var v_caption = new String(rElement.field_caption);
            var v_char_width = 8;
            var v_char_caption_width = 9.3;
            var v_caption_add = 2;
            var v_coll_add = 2;
            var v_sirka = 0;
            var v_sirka_nadpisu = 0;

            if (rElement.field_visible) {
                if (rElement.field_base_type === "TEXT") {
                    v_sirka = rElement.field_max_data_size;
                    if (v_sirka > maxCollChars)
                        v_sirka = maxCollChars;
                    if (v_sirka < 10)
                        v_sirka = 10;

                    v_sirka = (v_sirka + v_coll_add) * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addTextColumn(
                        {
                            name: rElement.field_name,
                            caption: rElement.field_caption,
                            width: v_sirka,
                            fixedWidth: false,
                            visible: rElement.field_visible,
                            description: ""
                        }
                    );
                }
                if (rElement.field_base_type === "NUMBER") {
                    v_sirka = 7;

                    v_sirka = v_sirka * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addNumberColumn(
                        {
                            name: rElement.field_name,
                            caption: rElement.field_caption,
                            width: v_sirka,
                            fixedWidth: true,
                            visible: rElement.field_visible,
                            description: ""
                        }
                    );
                }
                if (rElement.field_base_type === "DATE") {
                    v_sirka = 6;

                    v_sirka = v_sirka * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addDateColumn(
                        {
                            name: rElement.field_name,
                            caption: rElement.field_caption,
                            width: v_sirka,
                            fixedWidth: true,
                            visible: rElement.field_visible,
                            description: ""
                        }
                    );
                }
                if (rElement.field_base_type === "DATETIME") {

                    v_sirka = 16;

                    v_sirka = v_sirka * v_char_width;
                    v_sirka_nadpisu = (v_caption.length + v_caption_add) * v_char_caption_width;
                    if (v_sirka_nadpisu > v_sirka)
                        v_sirka = v_sirka_nadpisu;

                    lFormat.addDateTimeColumn(
                        {
                            name: rElement.field_name,
                            caption: rElement.field_caption,
                            width: v_sirka,
                            fixedWidth: true,
                            visible: rElement.field_visible,
                            description: ""
                        }
                    );
                }
                // jmena vsech sloupcu pro search
                if (rElement.field_visible) {
                    lSearch[lIndex++] = rElement.field_name;
                }
            }
        });
        // EACH
        var lObj: any = {};
        lObj.view = lView;
        lObj.format = lFormat;
        lObj.search = lSearch;
        return lObj;
    }

}